import { Directive, OnDestroy, OnInit, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { NgUploaderService, UploaderOptions, UploadOutput } from 'ngx-uploader';
import { Subscription } from 'rxjs';

import { CustomFileHandlerService } from './custom-file-handler.service';

@Directive({
  selector: '[ivFileSelect]'
})
export class CustomFileSelectDirective implements OnInit, OnDestroy {

  @Input() options: UploaderOptions;
  @Input() uploadInput: EventEmitter<any>;
  @Output() uploadOutput: EventEmitter<any>;

  upload: NgUploaderService;
  el: HTMLInputElement;
  serviceEvents: EventEmitter<any>;

  _sub: Subscription[];

  constructor(public elementRef: ElementRef, private customFileService: CustomFileHandlerService) {
    this.uploadOutput = new EventEmitter<any>();
  }

  ngOnInit() {
    this._sub = [];
    const concurrency = this.options && this.options.concurrency || Number.POSITIVE_INFINITY;
    const allowedContentTypes = this.options && this.options.allowedContentTypes || ['*'];
    // Below values are availabe as last two params of NgUploaderService in latest version
    // const maxUploads = this.options && this.options.maxUploads || Number.POSITIVE_INFINITY;
    // const maxFileSize = this.options && this.options.maxFileSize || Number.POSITIVE_INFINITY;
    this.upload = new NgUploaderService(concurrency, allowedContentTypes);

    this.el = this.elementRef.nativeElement;
    this.el.addEventListener('change', this.fileListener, false);

    this._sub.push(
      this.upload.serviceEvents.subscribe((event: UploadOutput) => {
        this.uploadOutput.emit(event);
      })
    );

    if (this.uploadInput instanceof EventEmitter) {
      this._sub.push(this.upload.initInputEvents(this.uploadInput));
    }
  }

  ngOnDestroy() {
    if (this.el) {
      this.el.removeEventListener('change', this.fileListener, false);
      this._sub.forEach(sub => sub.unsubscribe());
    }
  }

  fileListener = () => {
    if (this.el.files) {
      this.uploadOutput.emit({ type: 'newUploadStart' });
      this.customFileService.manipulateFiles(this.el.files).then(files => {
        this.upload.handleFiles(files);
      }).catch(err => console.log(err));
    }
  }

}
